<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <transition name="fade" mode="out-in">
            <RecoverForm :id="id"
                         :code="code"
                         @snackbar="openSnackbar($event)" />
          </transition>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar.show"
                  :timeout="2000">
        {{ snackbar.msg }}
        <v-btn color="accent"
               text
               @click="snackbar.show = false">
          Close
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import { snackbar } from '@/components/Mixins/Messages';

export default {
  props: ['code', 'id'],
  mixins: [snackbar],
  beforeRouteEnter(to, from, next) {
    if (!to.query.code) {
      next({
        path: '/forgot',
      });
    } else {
      next();
    }
  },
};
</script>
